/**
 * Concede consentimento de rastreamento automaticamente no carregamento da pagina,
 * sem aguardar interacao do visitante.
 *
 * Grava analytics / marketing / preferences / sale_of_data via Customer Privacy API
 * do Shopify, liberando os Web Pixels que dependem de consentimento.
 *
 * Nao injeta nem esconde interface: o banner nativo do Shopify segue sendo exibido
 * normalmente, e um clique em "Recusar" nele sobrescreve esta concessao.
 *
 * ATENCAO: isso dispensa a coleta de consentimento do visitante. A decisao de usar
 * este arquivo e do lojista e tem implicacoes de LGPD / GDPR / CPRA.
 */
(function () {
  'use strict';

  var POLL_INTERVAL = 150;
  var POLL_MAX_TRIES = 40; // ~6s

  var granted = false;

  function alreadyGranted(api) {
    if (typeof api.currentVisitorConsent !== 'function') return false;
    try {
      var consent = api.currentVisitorConsent() || {};
      return (
        consent.analytics === 'yes' &&
        consent.marketing === 'yes' &&
        consent.preferences === 'yes' &&
        consent.sale_of_data === 'yes'
      );
    } catch (e) {
      return false;
    }
  }

  function setConsent(api) {
    if (granted) return true;
    if (!api || typeof api.setTrackingConsent !== 'function') return false;

    if (alreadyGranted(api)) {
      granted = true;
      return true;
    }

    try {
      api.setTrackingConsent(
        {
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true
        },
        function (result) {
          // A API devolve { error: ... } quando falha.
          if (result && result.error) {
            console.warn('[tp-consent] setTrackingConsent falhou:', result.error);
            return;
          }
          granted = true;
        }
      );
      return true;
    } catch (e) {
      console.warn('[tp-consent] setTrackingConsent lancou excecao:', e);
      return false;
    }
  }

  /**
   * Tenta uma vez. Retorna true quando nao ha mais motivo pra seguir tentando:
   * consentimento enviado, ou o carregamento do feature foi iniciado.
   */
  function attempt() {
    var S = window.Shopify;
    if (!S) return false;

    if (S.customerPrivacy) return setConsent(S.customerPrivacy);

    if (typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        // err e um array de erros quando algo falha.
        if (err && err.length) {
          console.warn('[tp-consent] consent-tracking-api nao carregou:', err);
          return;
        }
        setConsent(window.Shopify && window.Shopify.customerPrivacy);
      });
      return true;
    }

    return false;
  }

  function start() {
    if (attempt()) return;

    // Shopify.loadFeatures vem do content_for_header e pode nao existir ainda.
    // Sem este retry a concessao falha em silencio e os pixels ficam bloqueados.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (attempt() || tries >= POLL_MAX_TRIES) {
        clearInterval(timer);
        if (tries >= POLL_MAX_TRIES && !granted) {
          console.warn(
            '[tp-consent] Customer Privacy API indisponivel apos ' +
              tries +
              ' tentativas. Consentimento nao foi concedido.'
          );
        }
      }
    }, POLL_INTERVAL);
  }

  start();
})();
